import { useContext, useEffect } from "react";
import "react-phone-number-input/style.css";
import { FlexColBox } from "../../common/components";
import { usePageTitle } from "../../common/hooks/usePageTitle";
import { FormContext } from "../../context";
import { spacing } from "../../styles/theme";
import { useThemeBreakpoints } from "../../utils/themeUtils";
import { CheckoutForm } from "../Cart/Cart";
import ResusableAddressForm from "./Address/ResusableAddressForm";
import { useUserAddress } from "../../common/hooks/useUserAddress";
import { AddressTypeEnum } from "../../types";

export const AddressContainer = () => {
  const { isMobile } = useThemeBreakpoints();
  usePageTitle("pages.cartAddress.title");
  const { formik } = useContext(FormContext);
  const { getAllUserAddresses } = useUserAddress();

  const { billingAddress, shippingAddress } = formik?.values as CheckoutForm;

  useEffect(() => {
    getAllUserAddresses();
    // eslint-disable-next-line
  }, []);

  return (
    <FlexColBox alignItems={!isMobile ? "end" : "center"}>
      <FlexColBox maxWidth={!isMobile ? 840 : undefined} width={"100%"}>
        <FlexColBox
          display="flex"
          flexDirection={"column"}
          gap={{ xs: spacing.mediumMobile, lg: spacing.mediumDesktop }}
        >
          <ResusableAddressForm
            currentAddress={shippingAddress}
            addressType={AddressTypeEnum.SHIPPING}
          />
          <ResusableAddressForm
            currentAddress={billingAddress}
            addressType={AddressTypeEnum.BILLING}
          />
        </FlexColBox>
      </FlexColBox>
    </FlexColBox>
  );
};
